import MuiContainer from '@mui/material/Container';

import { styled } from 'helpers';

import { Props } from './types';

// Bit of a hack to retain 'component' prop.
// https://github.com/mui-org/material-ui/issues/15695#issuecomment-498242520
export const Container = styled(MuiContainer)<Props>`` as typeof MuiContainer;
// @ts-ignore
Container.displayName = 'Container';

export default Container;
